export function setInSessionStorage(key, value, targetWindow) {
    try {
        // If session storage is not supported, it's a no-op.
        if (targetWindow.sessionStorage && targetWindow.sessionStorage.setItem) {
            targetWindow.sessionStorage.setItem(key, value);
        }
    }
    catch (error) {
        // If session storage is full or disabled, it's a no-op.
    }
}
export function getFromSessionStorage(key, targetWindow) {
    var item = null;
    try {
        // If session storage is not supported, it's a no-op.
        if (targetWindow.sessionStorage && targetWindow.sessionStorage.getItem) {
            item = targetWindow.sessionStorage.getItem(key);
        }
    }
    catch (error) {
        // If session storage is disabled, it's a no-op.
    }
    return item;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2Vzc2lvblN0b3JhZ2VIZWxwZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvVXRpbHMvU2Vzc2lvblN0b3JhZ2VIZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLG1CQUFtQixDQUNqQyxHQUFXLEVBQ1gsS0FBYSxFQUNiLFlBQW9CO0lBRXBCLElBQUk7UUFDRixxREFBcUQ7UUFDckQsSUFBSSxZQUFZLENBQUMsY0FBYyxJQUFJLFlBQVksQ0FBQyxjQUFjLENBQUMsT0FBTyxFQUFFO1lBQ3RFLFlBQVksQ0FBQyxjQUFjLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxLQUFLLENBQUMsQ0FBQztTQUNqRDtLQUNGO0lBQUMsT0FBTyxLQUFLLEVBQUU7UUFDZCx3REFBd0Q7S0FDekQ7QUFDSCxDQUFDO0FBRUQsTUFBTSxVQUFVLHFCQUFxQixDQUNuQyxHQUFXLEVBQ1gsWUFBb0I7SUFFcEIsSUFBSSxJQUFJLEdBQWtCLElBQUksQ0FBQztJQUMvQixJQUFJO1FBQ0YscURBQXFEO1FBQ3JELElBQUksWUFBWSxDQUFDLGNBQWMsSUFBSSxZQUFZLENBQUMsY0FBYyxDQUFDLE9BQU8sRUFBRTtZQUN0RSxJQUFJLEdBQUcsWUFBWSxDQUFDLGNBQWMsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7U0FDakQ7S0FDRjtJQUFDLE9BQU8sS0FBSyxFQUFFO1FBQ2QsZ0RBQWdEO0tBQ2pEO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDIn0=